import utils from '../../../Shared/utils.jsx';
import {
    hasLegacyScopeItems,
    migrateLegacyScopeToScopeScript as migrateLegacyScopeToScopeScriptCore,
} from './controlDesignerScopeScriptMigrateCore.js';

export {
    hasLegacyScopeItems,
    isScopeScriptEmpty,
    isScopeScriptUnset,
    shouldDeferScopeScriptInitialization,
} from './controlDesignerScopeScriptMigrateCore.js';

function createDefaultCompileDeps() {
    return {
        compile: (text) => utils.compile(null, text),
        compileObject: (model) => utils.compileObject(null, model),
        extractFilters: (segment) => utils.helpers.extractFilters(segment),
        parseExpressionWithFilters: (expr) => utils.parseExpressionWithFilters(expr),
    };
}

/**
 * Copy legacy Variables/Functions into ScopeScript and ScopePublic.
 * @param {Parameters<typeof migrateLegacyScopeToScopeScriptCore>[0]} input
 */
export function migrateLegacyScopeToScopeScript(input = {}) {
    return migrateLegacyScopeToScopeScriptCore(input, createDefaultCompileDeps());
}
